import { Header, Layout, Logo } from '@kanda-libs/ks-design-library';

import useHelpModal from 'components/HelpModal/useHelpModal';

import Content from './Content';

const Mobile: React.FunctionComponent = function () {
  const { showHelpModal } = useHelpModal();
  return (
    <Layout
      noBorder
      header={
        <Header.Base lines hideNumber help={showHelpModal}>
          <Logo />
        </Header.Base>
      }
    >
      <Content />
    </Layout>
  );
};

export default Mobile;
